import React, { useEffect } from "react";
import { DashboardsEmbedWrapper } from "./dashboardEmbed";
import PropTypes from 'prop-types';
import { cookieAttributes } from "util/resumeCookieSettings";
import { Breadcrumbs } from "features/breadcrumb/breadcrumbs";
import classes from '../Dashboard.module.scss';

function DashboardVisualizationReportPage(props) {
  const dashboardId = props?.match?.params?.dashboardId?.trim();

  const historyProps = props?.location?.state;
  const activeTab = historyProps?.activeTab || 'Shared';
  const dashboardName = historyProps?.dashboardName || '';
  const dashboardDescription = historyProps?.dashboardDescription || 'An interactive QuickSight dashboard accessible within Market Insights';

  const activeTabName = activeTab === 'owned' ? 'My' : 'Shared';

  const breadCrumbsItems = [
    { label: "Home", to: "/" },
    { label: "Dashboards", to: "/dashboards" },
    { label: `${activeTabName} Dashboards`, to: `/dashboards/${activeTab}` },
    { label: `Visualize ${dashboardName}`, to: `/dashboardVisualization/${dashboardId}` }
  ];

  useEffect(() => {
    if (dashboardId) {
      async function setResumeCookie() {
        const cookieValue = encodeURIComponent(`Dashboard Visualization - /dashboardVisualization/${dashboardId}`);
        const resumeCookie = Object.assign(cookieAttributes(), { name: 'platform_resume' }, { value: cookieValue });
        await cookieStore.set(resumeCookie);
      }
      setResumeCookie();
    }
  }, [dashboardId]);

  return (
    <div className={`query-wrapper ${classes["dashboard-wrapper"]}`}>
      <Breadcrumbs items={breadCrumbsItems} />
      <div className={classes["head-wrapper"]}>
        <h3 className={classes["heading"]}>Dashboard Visualization {dashboardName}</h3>
        <span className={classes["subtitle"]}>
          {dashboardDescription}
        </span>
      </div>
      <div>
        {dashboardId ? (
          <DashboardsEmbedWrapper dashboardId={dashboardId} />
        ) : (
          <div className="alert alert-warning">No dashboard specified</div>
        )}
      </div>
    </div>
  );
}

DashboardVisualizationReportPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      dashboardId: PropTypes.string
    })
  })
};

export default DashboardVisualizationReportPage;